import { useNavigate } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

export const ServiceDialog = ({ service, onClose }) => {
  const navigate = useNavigate();
  const Icon = service?.icon;
  return (
    <Dialog open={!!service} onOpenChange={(o) => !o && onClose()}>
      <DialogContent
        className="bg-[#0a0a0a] border-[#262626] text-white max-w-2xl p-0 gap-0 rounded-none [&>button]:text-white/60 [&>button]:hover:text-[#FACC15]"
        data-testid="service-dialog"
      >
        {service && (
          <>
            <DialogHeader className="p-8 pb-6 border-b border-[#1a1a1a] text-left">
              <div className="flex items-center gap-4 mb-5">
                <div className="w-12 h-12 flex items-center justify-center border border-[#FACC15]/40 bg-[#FACC15]/5">
                  <Icon size={22} color="#FACC15" strokeWidth={1.8} />
                </div>
                <p className="eyebrow">Area di consulenza</p>
              </div>
              <DialogTitle
                className="text-3xl sm:text-4xl font-bold leading-tight"
                style={{ fontFamily: "'Outfit', sans-serif", letterSpacing: "-0.025em" }}
                data-testid="service-dialog-title"
              >
                {service.name}
              </DialogTitle>
              <DialogDescription className="text-white/70 text-base leading-relaxed pt-3">
                {service.long}
              </DialogDescription>
            </DialogHeader>

            <div className="p-8 pt-6">
              <p className="text-xs tracking-[0.2em] uppercase text-white/50 mb-4">Cosa facciamo concretamente</p>
              <ul className="grid grid-cols-1 sm:grid-cols-2 gap-3" data-testid="service-dialog-points">
                {service.points.map((p) => (
                  <li key={p} className="flex items-start gap-3 text-sm text-white/80 leading-relaxed">
                    <Check size={16} className="text-[#FACC15] mt-0.5 shrink-0" />
                    {p}
                  </li>
                ))}
              </ul>
              <button
                type="button"
                onClick={() => navigate(`/contatti?service=${encodeURIComponent(service.name)}`)}
                className="btn-yellow mt-8 inline-flex items-center gap-2 group"
                data-testid="service-dialog-cta"
              >
                Richiedi informazioni
                <ArrowRight size={18} className="transition-transform group-hover:translate-x-1" />
              </button>
            </div>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ServiceDialog;
